import ReactDOM from 'react-dom';
import './Dimensions.scss';


const Dimensions = (props) => {

  
   const {list } = props;
   const dimensionData = list.dimensionData;
   // console.log('dimension called..... ', dimensionData);

   
   return (
      <>
         {dimensionData.map((hotspot) =>  {
                     const imageSrc = window.isMobIsipadIsPotrait ? (hotspot?.mobIcon || hotspot?.icon) : hotspot?.icon;   // DN - Use mobIcon for mobile/portrait, otherwise use icon 

            return (
            ReactDOM.createPortal(
               <div onKeyDown={(event) => {
                  if (event.key !== 'Enter') {
                        return
                     } props.handleMenuClick(list, event)
                  }} onClick={(event) => {
                     props.handleMenuClick(list, event)
                  }} id={hotspot.hsname}  className={ `dimensions popupbox tempHotspot hsParentType_${hotspot.hsParentType} hotspotMenuId_${list.id} ${window.selectedConfig['currentSelectedSubmenu'] === hotspot.popupId ? 'active' : ''}`} data-info={JSON.stringify(hotspot)}>
                     {/* <div className="" id="dimensionsWrapper">  */}


                        {(!hotspot.icon && !hotspot.icon2) 
                        ? (<span className='dimensionTextOnly'>{hotspot.diamension_text}</span>) : 
                        (
                           <div className='dimensionWithIcon'> 
                              <img src={imageSrc} alt={list.popupHeading} />
                              <span className='dimensionText'>{hotspot.diamension_text}</span>
                              {hotspot.icon2 && <img src={hotspot.icon2} alt={list.popupHeading} />}
                           </div>
                        )}

               </div>, document.getElementById('dimensionsWrapper'))
            )
         })}
      </>
   )
}

export default Dimensions

